import { z } from 'zod';

import { OrderDirection } from '@/constants/orderDirection';

/**
 * サーバーサイドで並び替え可能な列。
 * API (`/v2/software-provisioning-activities` の orderBy) が受け付ける値と一致させる。
 */
export const ActivitySortColumn = {
  OCCURRED_AT: 'occurredAt',
  ACTIVITY_TYPE: 'activityType',
} as const;
export type ActivitySortColumn =
  (typeof ActivitySortColumn)[keyof typeof ActivitySortColumn];

export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  activityTypes: z.array(z.string()).optional(),
  softwareId: z.string().optional(),
  personId: z.string().optional(),
  startAt: z.string().optional(),
  endAt: z.string().optional(),
  // 並び替えは URL に保持し、サーバーサイドで全件に適用する（DC-7991）。
  // 既定は発生日時の降順（最新が先頭）で、バックエンドの既定順とも一致する。
  sortColumn: z
    .nativeEnum(ActivitySortColumn)
    .default(ActivitySortColumn.OCCURRED_AT),
  sortOrder: z.nativeEnum(OrderDirection).default(OrderDirection.DESC),
});
